import { Navigate, Route, Routes } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { Layout } from "./components/Layout/Layout";
import { routes } from "./config/routes";
import { useAuth } from "./helpers/useAuth";
import "./styles/global.scss";

// Define a protected route wrapper
const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          {Object.entries(routes).map(([key, value]) => {
            const RouteComponent = () => <value.component />;
            
            return (
              <Route
                key={`route_${key}`}
                path={value.path}
                element={
                  value.protected ? (
                    <ProtectedRoute>
                      <RouteComponent />
                    </ProtectedRoute>
                  ) : (
                    <RouteComponent />
                  )
                }
              />
            );
          })}
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
